module.exports = new __parcel__URL__("generic-error.f200ded6.svg").toString();